import React from 'react'
import Svg, { SvgType } from 'components/svgComponent/Svg'

export default function(props: SvgType) {
  return (
    <Svg width="42" height="43" viewBox="0 0 42 43" fill="none" {...props}>
      <rect y="0.810059" width="42" height="42" rx="21" fill="#286EFA" />
      <path
        d="M29.8442 17.0826C29.7502 16.7069 29.5586 16.3626 29.289 16.0846C29.0193 15.8066 28.6811 15.6047 28.3084 15.4992C26.9467 15.1667 21.5 15.1667 21.5 15.1667C21.5 15.1667 16.0534 15.1667 14.6917 15.5309C14.319 15.6364 13.9808 15.8383 13.7111 16.1163C13.4414 16.3943 13.2499 16.7385 13.1559 17.1142C12.9067 18.4961 12.7848 19.898 12.7917 21.3022C12.7828 22.7169 12.9047 24.1294 13.1559 25.5217C13.2596 25.8858 13.4554 26.2169 13.7244 26.4832C13.9934 26.7495 14.3266 26.9419 14.6917 27.0417C16.0534 27.4059 21.5 27.4059 21.5 27.4059C21.5 27.4059 26.9467 27.4059 28.3084 27.0417C28.6811 26.9363 29.0193 26.7344 29.289 26.4564C29.5586 26.1784 29.7502 25.8341 29.8442 25.4584C30.0915 24.0869 30.2134 22.6958 30.2084 21.3022C30.2173 19.8874 30.0954 18.4749 29.8442 17.0826Z"
        stroke="white"
        strokeWidth="1.58333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7188 23.8909L24.2709 21.3022L19.7188 18.7134V23.8909Z"
        stroke="white"
        strokeWidth="1.58333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
